import React, { FC } from 'react';
import { ExpertiseComponentContainer, FormContainer } from '../../../../styles/styled';
import { NmsMemberType } from '../../../NmsMembers/types';

type NmsProfileComponentProps = {
  currentNms: NmsMemberType | null;
};

export const NmsProfileComponent: FC<NmsProfileComponentProps> = ({ currentNms }) => {
  return (
    <ExpertiseComponentContainer>
      <FormContainer padding="30px 20px 150px 20px" background={'#fff'}>
        <div className="big-text">
          {currentNms?.lastname} {currentNms?.firstname} {currentNms?.patronymic}
        </div>
        <div className="text">Email: {currentNms?.email}</div>
      </FormContainer>
    </ExpertiseComponentContainer>
  );
};
